
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 20.05c-7.8 0-12-5.7-12-8.04s4.2-8.03 12-8.03S24 9.68 24 12s-4.2 8.04-12 8.04zm0-15.07C4.78 4.98 1 10.2 1 12s3.78 7.04 11 7.04S23 13.82 23 12s-3.78-7.03-11-7.03z"}}),_c('path',{attrs:{"d":"M12 16.57a4.56 4.56 0 114.56-4.56A4.56 4.56 0 0112 16.57zm0-8.11A3.56 3.56 0 1015.56 12 3.56 3.56 0 0012 8.46z"}}),_c('path',{attrs:{"d":"M19.26 19.95a.5.5 0 01-.36-.14l-15-15a.5.5 0 11.71-.71l15 15a.5.5 0 01-.35.85z"}})])
          )
        }
      }
    